import { isDwellerRole } from '../../../utils/user'
import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../Entity'

import {
  REQUEST_PROFILE_HEADER_INFO_ITEM_ACTION_QA_NAMES,
  REQUEST_PROFILE_HEADER_INFO_ITEM_ADD_TOOLTIP_KEYS,
  RequestProfileHeaderInfoItemName,
} from './RequestProfileHeaderInfoItem.constants'

export function isRequestProfileHeaderInfoItemNameBuilding(name) {
  return name === RequestProfileHeaderInfoItemName.Building
}

export function getRequestProfileHeaderInfoItemActionsProps(name) {
  const addTooltipKey = REQUEST_PROFILE_HEADER_INFO_ITEM_ADD_TOOLTIP_KEYS[name]
  const qaNames = REQUEST_PROFILE_HEADER_INFO_ITEM_ACTION_QA_NAMES[name]

  return qaNames
    ? {
        buttonsProps: {
          [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: {
            qaName: qaNames.add,
            tooltip: addTooltipKey,
          },
          [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: {
            qaName: qaNames.edit,
          },
        },
      }
    : undefined
}

export function getRequestProfileHeaderInfoItemBaseProps({
  canEdit,
  contentWrapperClassName,
  editFieldsWrapperClassName,
  itemActionsWrapperClassName,
  name,
  noDataTextClassName,
  titleClassName,
}) {
  const actionsProps = getRequestProfileHeaderInfoItemActionsProps(name)

  return {
    actions: canEdit ? undefined : null,
    canEdit,
    contentWrapperClassName,
    editFieldsWrapperClassName,
    itemActionsProps: canEdit
      ? actionsProps
        ? {
            ...actionsProps,
            actionsWrapperClassName: itemActionsWrapperClassName,
          }
        : { actionsWrapperClassName: itemActionsWrapperClassName }
      : undefined,
    noDataTextClassName,
    titleClassName,
  }
}

export function isRequestProfileHeaderInfoItemDeadline(name) {
  return name === RequestProfileHeaderInfoItemName.Deadline
}

export function isRequestProfileHeaderOwnerVisibilityIconVisible(requestData) {
  if (requestData?.owner) {
    return requestData?.visible_to_dwellers && isDwellerRole(requestData.owner)
  }

  return false
}

export function isRequestProfileHeaderOwnerNeedToShowIcons({
  isArchived,
  isHovered,
  isOwnerVisibilityIconVisible,
}) {
  return isArchived || isHovered || isOwnerVisibilityIconVisible
}
